import React from "react";
import { useSelector } from "react-redux";
import { graphql } from "gatsby";
import { HomeWrapper } from "../elements";
import { Container, FeatureImage, Seo } from "../components";
import { MDXRenderer } from "gatsby-plugin-mdx";

const Home = ({ location, data }) => {
  const locale = useSelector((state) => state.localeString);
  const isDark = useSelector((state) => state.isDark);
  return (
    <Container pathname={location.pathname} isDark={isDark} locale={locale}>
      <Seo />
      <HomeWrapper isDark={isDark}>
        <div className={"top"}>
          <FeatureImage />
        </div>
        <h3>{data.allMdx.edges[0].node.frontmatter.title}</h3>
        <br />
        <MDXRenderer>{data.allMdx.edges[0].node.body}</MDXRenderer>
      </HomeWrapper>
    </Container>
  );
};
export default Home;

export const homeTemplateQuery = graphql`
  query HomeTemplateQuery($locale: String!) {
    allMdx(
      filter: {
        frontmatter: { motives: { eq: "home" }, locale: { eq: $locale } }
      }
    ) {
      edges {
        node {
          body
          frontmatter {
            slug
            title
          }
        }
      }
    }
  }
`;
